import React from 'react';
import { 
  Typography, 
  Autocomplete, 
  TextField, 
  Button, 
  Paper,
  Box
} from '@mui/material';
import { FaEdit } from 'react-icons/fa';

const PaymentStep = ({
  paymentList,
  paymentSelected,
  setPaymentSelected,
  errors,
  control,
  Controller,
  selectedAddress,
  addressList,
  onNext,
  onBack,
  onEditAddress
}) => {
  return (
    <div>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Forma de Pagamento
      </Typography>

      {selectedAddress && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, bgcolor: '#f8f9fa' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <div>
              <Typography variant="subtitle2" color="textSecondary">
                Endereço de entrega:
              </Typography>
              <Typography variant="body2">
                {addressList.find(addr => addr.ID_DM002 === selectedAddress)?.NM_ENDERECO}
              </Typography>
            </div>
            <Button
              variant="contained"
              size="small"
              startIcon={<FaEdit />}
              onClick={onEditAddress}
              style={{
                fontWeight: 'bold',
                textTransform: 'none',
                padding: '8px 16px',
                backgroundColor: 'black'
              }}
            >
              Alterar
            </Button>
          </Box>
        </Paper>
      )}
      
      <div style={{ maxWidth: '500px', marginBottom: '24px' }}>
        <Controller
          name="paymentSelected"
          control={control}
          render={({ field }) => (
            <Autocomplete
              {...field}
              options={paymentList}
              getOptionLabel={(option) => option.DS_FORMA_PAGAMENTO || ""}
              value={paymentList.find((payment) => payment.DS_FORMA_PAGAMENTO === field.value) || null}
              onChange={(event, newValue) => {
                setPaymentSelected(newValue?.DS_FORMA_PAGAMENTO || "");
                field.onChange(newValue?.DS_FORMA_PAGAMENTO || "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Forma de Pagamento"
                  error={!!errors.paymentSelected}
                  helperText={errors.paymentSelected?.message}
                  fullWidth
                />
              )}
            />
          )}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
        <Button
          variant="outlined"
          onClick={onBack}
          size="large"
          sx={{ 
            px: 4,
            borderColor: 'black',
            color: 'black',
            '&:hover': {
              borderColor: 'black',
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={!paymentSelected}
          size="large"
          sx={{ 
            px: 4,
            backgroundColor: 'black',
            '&:hover': {
              backgroundColor: '#333'
            }
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default PaymentStep;
